import { useSyncExternalStore, useCallback } from 'react'

// createLocalStorageSync の sessionStorage 版。 タブ閉じで消えてほしい
// 「セッション内一時的な選択」 (例: タブの選択) に使う。 ブラウザ全体で
// 共有する「個人の好み」 (並び順、表示モード等) は localStorage 側を使う。
export function createSessionStorageSync<T extends string>(
  storageKey: string,
  defaultValue: T,
  validate: (raw: string | null) => T | null,
) {
  const listeners = new Set<() => void>()

  function getSnapshot(): T {
    const raw = sessionStorage.getItem(storageKey)
    return validate(raw) ?? defaultValue
  }

  function subscribe(callback: () => void) {
    listeners.add(callback)
    return () => listeners.delete(callback)
  }

  function useStore(): readonly [T, (value: T) => void] {
    const value = useSyncExternalStore(subscribe, getSnapshot)

    const setValue = useCallback((next: T) => {
      sessionStorage.setItem(storageKey, next)
      listeners.forEach((l) => l())
    }, [])

    return [value, setValue] as const
  }

  return useStore
}
